import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import React from 'react'
import { useTranslation } from 'react-i18next';

interface ButtonSubmitProps {
    loadingBtn: boolean;
}

const ButtonSubmit = (props: ButtonSubmitProps) => {
    const { loadingBtn } = props;
    const { t } = useTranslation();
    return (
        <Box 
            display={"flex"} 
            justifyContent={"flex-end"} 
            mt={3} 
            className="position-sticky bottom-20 zIndex-100"
            >
            <Button disabled={loadingBtn} type="submit" variant="contained" className="w-150">
                {t("saveButton")}
            </Button>
        </Box>
    )
}

export default ButtonSubmit
